"use strict";
const logoClut = [
    [0, 0, 0, 255],
    [255, 0, 0, 255],
    [0, 255, 0, 255],
    [255, 255, 0, 255],
    [0, 0, 255, 255],
    [255, 0, 255, 255],
    [0, 255, 255, 255],
    [255, 255, 255, 255],
    [0, 0, 0, 0],
    [170, 0, 0, 255],
    [0, 170, 0, 255],
    [170, 170, 0, 255],
    [0, 0, 170, 255],
    [170, 0, 170, 255],
    [0, 170, 170, 255],
    [170, 170, 170, 255],
    [0, 0, 85, 255],
    [0, 85, 0, 255],
    [0, 85, 85, 255],
    [0, 85, 170, 255],
    [0, 85, 255, 255],
    [0, 170, 85, 255],
    [0, 170, 255, 255],
    [0, 255, 85, 255],
    [0, 255, 170, 255],
    [85, 0, 0, 255],
    [85, 0, 85, 255],
    [85, 0, 170, 255],
    [85, 0, 255, 255],
    [85, 85, 0, 255],
    [85, 85, 85, 255],
    [85, 85, 170, 255],
    [85, 85, 255, 255],
    [85, 170, 0, 255],
    [85, 170, 85, 255],
    [85, 170, 170, 255],
    [85, 170, 255, 255],
    [85, 255, 0, 255],
    [85, 255, 85, 255],
    [85, 255, 170, 255],
    [85, 255, 255, 255],
    [170, 0, 85, 255],
    [170, 0, 255, 255],
    [170, 85, 0, 255],
    [170, 85, 85, 255],
    [170, 85, 170, 255],
    [170, 85, 255, 255],
    [170, 170, 85, 255],
    [170, 170, 255, 255],
    [170, 255, 0, 255],
    [170, 255, 85, 255],
    [170, 255, 170, 255],
    [170, 255, 255, 255],
    [255, 0, 85, 255],
    [255, 0, 255, 255],
    [255, 85, 0, 255],
    [255, 85, 85, 255],
    [255, 85, 170, 255],
    [255, 85, 255, 255],
    [255, 170, 0, 255],
    [255, 170, 85, 255],
    [255, 170, 170, 255],
    [255, 170, 255, 255],
    [255, 255, 85, 255],
    [255, 255, 255, 255],
    [0, 0, 0, 128],
    [255, 0, 0, 128],
    [0, 255, 0, 128],
    [255, 255, 0, 128],
    [0, 0, 255, 128],
    [255, 0, 255, 128],
    [0, 255, 255, 128],
    [255, 255, 255, 128],
    [170, 0, 0, 128],
    [0, 170, 0, 128],
    [170, 170, 0, 128],
    [0, 0, 170, 128],
    [170, 0, 170, 128],
    [0, 170, 170, 128],
    [170, 170, 170, 128],
    [0, 0, 85, 128],
    [0, 85, 0, 128],
    [0, 85, 85, 128],
    [0, 85, 170, 128],
    [0, 85, 255, 128],
    [0, 170, 85, 128],
    [0, 170, 255, 128],
    [0, 255, 85, 128],
    [0, 255, 170, 128],
    [85, 0, 0, 128],
    [85, 0, 85, 128],
    [85, 0, 170, 128],
    [85, 0, 255, 128],
    [85, 85, 0, 128],
    [85, 85, 85, 128],
    [85, 85, 170, 128],
    [85, 85, 255, 128],
    [85, 170, 0, 128],
    [85, 170, 85, 128],
    [85, 170, 170, 128],
    [85, 170, 255, 128],
    [85, 255, 0, 128],
    [85, 255, 85, 128],
    [85, 255, 170, 128],
    [85, 255, 255, 128],
    [170, 0, 85, 128],
    [170, 0, 255, 128],
    [170, 85, 0, 128],
    [170, 85, 85, 128],
    [170, 85, 170, 128],
    [170, 85, 255, 128],
    [170, 170, 85, 128],
    [170, 170, 255, 128],
    [170, 255, 0, 128],
    [170, 255, 85, 128],
    [170, 255, 170, 128],
    [170, 255, 255, 128],
    [255, 0, 85, 128],
    [255, 0, 255, 128],
    [255, 85, 0, 128],
    [255, 85, 85, 128],
    [255, 85, 170, 128],
    [255, 85, 255, 128],
    [255, 170, 0, 128],
    [255, 170, 85, 128],
    [255, 170, 170, 128],
    [255, 170, 255, 128],
    [255, 255, 85, 128],
    [255, 255, 255, 128]
];
module.exports = logoClut;
//# sourceMappingURL=logo_clut.js.map